import { render, staticRenderFns } from "./provision.vue?vue&type=template&id=4c3a48bd&scoped=true"
import script from "./provision.vue?vue&type=script&lang=js"
export * from "./provision.vue?vue&type=script&lang=js"
import style0 from "./provision.vue?vue&type=style&index=0&id=4c3a48bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a48bd",
  null
  
)

export default component.exports